'use strict';

angular.module('rmOrganisation', ['angularPayments']);

require('./controller');
require('./resources');
require('./directives');
require('./routes');
require('./filters');
